import React, { useState } from 'react';
import { Dashboard, DashboardBackButton, PageLayout } from '@components';
import { HeadContent, Select, Subsection } from '@fourthwall/components';
import { isProduction } from '@fourthwall/utils';
import { useCollectionsQuery } from '@modules/Dashboard/Collections/queries/useCollectionsQuery';
import { useCurrentShopQuery } from '@modules/Dashboard/hooks/useCurrentShopQuery';
import { routing } from '@utils/routing';
import linktreeSignet from '../../assets/signets/linktree.svg';
import { ConnectBar } from '../../components/ConnectBar/ConnectBar';
export const AppsLinktree = () => {
    const { currentShopQuery } = useCurrentShopQuery();
    const { collectionsQuery } = useCollectionsQuery();
    const [selectedCollection, setSelectedCollection] = useState('all');
    const publicCollections = (collectionsQuery.data || [])
        .filter((collection) => collection.state.status === 'PUBLIC')
        .map((collection) => ({
        value: collection.slug,
        label: collection.name,
    }));
    const internalDomain = currentShopQuery.data?.internalDomain;
    const suffix = isProduction() ? 'fourthwall.com' : 'staging.fourthwall.com';
    const shopUrl = internalDomain ? `${internalDomain}.${suffix}` : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Linktree" }),
        React.createElement(PageLayout, { size: "tiny" },
            React.createElement(Dashboard.Section, { name: "Linktree", topContent: React.createElement(DashboardBackButton, { label: "Apps", to: routing.apps.self }) },
                React.createElement(Subsection, null, shopUrl && (React.createElement(ConnectBar, { logoSrc: linktreeSignet, info: React.createElement(Select, { options: publicCollections, label: "Select a collection to display on your Linktree", value: selectedCollection, onValueChange: setSelectedCollection, fullWidth: true }), connectButtonLabel: "Add", onConnect: () => {
                        window.open(`${routing.external.linktree.createLink}&url=${encodeURIComponent(`https://${shopUrl}/collections/${selectedCollection}`)}`, '_blank');
                    } })))))));
};
